import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router';
import Projects from '../views/Projects.vue';
import Project from '../views/Project.vue';
import NewProject from '../views/ProjectNew.vue';
import Login from '../views/Login.vue';
import Template from '../views/Template.vue';
import NewTemplate from '../views/TemplateNew.vue';
import Organizations from '../views/Organizations.vue';
import NewOrganization from '../views/OrganizationNew.vue';
import Organization from '../views/Organization.vue';
import Accounts from '../views/Accounts.vue';
import NewAccount from '../views/AccountNew.vue';
import Account from '../views/Account.vue';
import Register from '@/views/Register.vue';
import UploadJson from '@/views/UploadJson.vue';

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'Organizations',
    component: Organizations,
  },
  {
    path: '/new',
    name: 'NewOrganization',
    component: NewOrganization,
  },
  {
    path: '/organizations/:org_slug',
    name: 'Organization',
    component: Organization,
  },
  {
    path: '/accounts',
    name: 'Accounts',
    component: Accounts,
  },
  {
    path: '/accounts/new',
    name: 'NewAccount',
    component: NewAccount,
  },
  {
    path: '/accounts/:slug',
    name: 'Account',
    component: Account,
  },
  {
    path: '/organizations/:org_slug/projects',
    name: 'Projects',
    component: Projects,
  },
  {
    path: '/organizations/:org_slug/projects/new',
    name: 'NewProject',
    component: NewProject,
  },
  {
    path: '/organizations/:org_slug/projects/:prj_slug',
    name: 'Project',
    component: Project,
  },
  {
    path: '/organizations/:org_slug/projects/:prj_slug/template/new',
    name: 'NewTemplate',
    component: NewTemplate,
  },
  {
    path: '/organizations/:org_slug/projects/:prj_slug/template/:tmpl_slug',
    name: 'Template',
    component: Template,
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
  },
  {
    path: '/register',
    name: 'Register',
    component: Register,
  },
  {
    path: '/upload-json-file',
    name: 'UploadFile',
    component: UploadJson,
  },
];

function getCookie(name: string) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop()?.split(';').shift();
  return null;
}

const router = createRouter({
  history: createWebHistory(process.env.VUE_APP_BASE_URL),
  routes,
});

const publicRoutes = ['/login', '/register'];

router.beforeEach(async (to, from, next) => {
  const isPublic = publicRoutes.includes(to.path);
  if (isPublic) return next();

  if (!getCookie('accessToken')) {
    return next({ path: '/login' });
  }
  return next();
});
export default router;
